import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  '@global body': {
    backgroundColor: theme.palette.common.white,
  },
  customType1: {
    fontSize: theme.typography.pxToRem(20),
    lineHeight: theme.typography.pxToRem(26),
  },
  customType2: {
    fontSize: theme.typography.pxToRem(40),
    lineHeight: theme.typography.pxToRem(49),
    fontWeight: theme.typography.fontWeightBold,
  },
}));
